const trunc = Math.trunc;

const round = Math.round;

const length = (len: number) => (val: string) => val.slice(0, len);

const trim = (val: string) => val.trim();

const constant =
  <T>(val: T) =>
  () =>
    val;

const optional =
  <T>(fn: (val: T) => T) =>
  (val?: T) =>
    val === undefined ? undefined : fn(val);

const array =
  <T>(fn: (val: T) => T) =>
  (val: T[]) =>
    val.map(fn);

export const formatter = {
  trunc,
  round,
  length,
  trim,
  constant,
  optional,
  array,
};
